import { t } from './i18n/index.js';
import { S, persist } from './state.js';
import { RT, render } from './ui.js';

export const mq=window.matchMedia('(prefers-color-scheme: dark)');
export function resolvedMode(){return S.settings.theme==='auto'?(mq.matches?'dark':'light'):S.settings.theme}
export const SUNICON='<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 2.5V5M12 19v2.5M2.5 12H5M19 12h2.5M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M19.1 4.9l-1.8 1.8M6.7 17.3l-1.8 1.8"/></svg>';
export const MOONICON='<svg viewBox="0 0 24 24"><path d="M20.2 14.8A8.3 8.3 0 0 1 9.2 3.8a8.3 8.3 0 1 0 11 11z"/></svg>';
export function updateThemeIcons(){
  const dark=resolvedMode()==='dark';
  document.querySelectorAll('[data-theme-toggle]').forEach(b=>{
    b.innerHTML=dark?SUNICON:MOONICON;
    b.title=dark?t('set.t.light'):t('set.t.dark');
  });
}
export function applyTheme(){
  document.documentElement.setAttribute('data-mode',resolvedMode());
  updateThemeIcons();
  if(window.__bg)window.__bg.retint();
}
const LANGS=['de','en','fr'];
export function updateLangButtons(){document.querySelectorAll('[data-lang-toggle]').forEach(b=>{b.textContent=(S.settings.lang||'en').toUpperCase();b.title=({de:'Deutsch',en:'English',fr:'Français'})[S.settings.lang]||''})}
export function initTheme(){
  updateLangButtons();
  document.querySelectorAll('[data-lang-toggle]').forEach(b=>b.onclick=()=>{
    const i=LANGS.indexOf(S.settings.lang);S.settings.lang=LANGS[(i+1)%LANGS.length];
    persist();updateLangButtons();render();
  });
mq.addEventListener('change',()=>{if(S.settings.theme==='auto')applyTheme()});
document.querySelectorAll('[data-theme-toggle]').forEach(b=>b.onclick=()=>{
  S.settings.theme=resolvedMode()==='dark'?'light':'dark';
  persist();applyTheme();
  if(RT.v==='settings')render();
});

/* ================= PWA manifest (best effort, single-file) ================= */
}
